import { render, staticRenderFns } from "./person-buyed.vue?vue&type=template&id=30bf4fea&"
import script from "./person-buyed.vue?vue&type=script&lang=js&"
export * from "./person-buyed.vue?vue&type=script&lang=js&"
import style0 from "./person-buyed.vue?vue&type=style&index=0&id=30bf4fea&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports